const scope = {
    name_exists: 'ชื่อขอบเขต {{name}} ถูกใช้งานแล้ว',
    name_with_space: 'ชื่อของขอบเขตไม่สามารถมีช่องว่างได้',
};
export default Object.freeze(scope);
